import {calendarSvg as Icon__small__calendarSvg} from '../Icon__small/Icon__small--calendar.js';

export var calendar = {
  name: 'calendar',
  category: 'icon',
  colorable: true,
  svg: Icon__small__calendarSvg,
};
